/**
 * 门户文本默认配置数据
 */
export const home = [
  // {
  //   type: 1,
  //   thumbnail: "icon-portal-layout_1"
  // },
  // {
  //   type: 2,
  //   thumbnail: "icon-portal-layout_2"
  // },
  // {
  //   type: 3,
  //   thumbnail: "icon-portal-layout_3"
  // },
  // {
  //   type: 4,
  //   thumbnail: "icon-portal-layout_4"
  // },
  // {
  //   type: 5,
  //   thumbnail: "icon-portal-layout_5"
  // },
  // {
  //   type: 6,
  //   thumbnail: "icon-portal-layout_6"
  // },
  {
    type: 7,
    thumbnail: "icon-portal-layout_7"
  },
  {
    type: 8,
    thumbnail: "icon-portal-layout_8"
  },
  {
    type: 10,
    thumbnail: "icon-portal-accordion",
    height: 480
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  // {
  //   type: 1,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_1.png")
  // },
  // {
  //   type: 2,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_2.png")
  // },
  // {
  //   type: 3,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_3.png")
  // },
  // {
  //   type: 4,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_4.png")
  // },
  // {
  //   type: 5,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_5.png")
  // },
  // {
  //   type: 6,
  //   thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_6.png")
  // }
]

/**
 * app按钮默认配置数据
 */
export const appHome = [
  // {
  //   type: 1,
  //   thumbnail: "icon-portal-layout_1"
  // },
  // {
  //   type: 2,
  //   thumbnail: "icon-portal-layout_2"
  // },
  // {
  //   type: 3,
  //   thumbnail: "icon-portal-layout_3"
  // },
  // {
  //   type: 4,
  //   thumbnail: "icon-portal-layout_4"
  // },
  // {
  //   type: 5,
  //   thumbnail: "icon-portal-layout_5"
  // },
  // {
  //   type: 6,
  //   thumbnail: "icon-portal-layout_6"
  // },
  {
    type: 7,
    thumbnail: "icon-portal-layout_7"
  },
  {
    type: 8,
    thumbnail: "icon-portal-layout_8"
  },
  {
    type: 10,
    thumbnail: "icon-portal-accordion",
    height: 480
  }
]
